export default "__VITE_ASSET__428c5d6f__"